import React, { useState, useEffect } from "react";
import ArticalListBanner from "./ArticalListBanner";
import { Col, Container, Row, Spinner, Alert, Button } from "react-bootstrap";
import ArticlesCard from "./ArticlesCard";
import CategorisRecentPost from "./CategorisRecentPost";
import apiCall from "../../Api/api";

function ArticalList() {
  const [articles, setArticles] = useState([]);
  const [loading, setLoading] = useState(true);
  const [loadingMore, setLoadingMore] = useState(false);
  const [error, setError] = useState(null);
  const [page, setPage] = useState(1);
  const [hasMore, setHasMore] = useState(true);

  const fetchArticles = async (currentPage = 1) => {
    try {
      if (currentPage === 1) {
        setLoading(true);
      } else {
        setLoadingMore(true);
      }

      const response = await apiCall({
        url: `posts?page=${currentPage}`, 
        method: "GET",
        headers: "",
      });

      

      if (response?.status === 200) {
        const postData = response?.data?.UserPosts?.data || [];

        setArticles((prev) => {
          const existingIds = new Set(prev.map((a) => a.id));
          const newArticles = postData.filter((a) => !existingIds.has(a.id));
          return [...prev, ...newArticles];
        });
        
        setHasMore(postData.length > 0); 
      } else {
        throw new Error("Failed to load articles.");
      }
    } catch (err) {
      setError(err.message || "Something went wrong!");
    } finally {
      setLoading(false);
      setLoadingMore(false);
    }
  };

  useEffect(() => {
    fetchArticles(page);
  }, [page]);

  const handleLoadMore = () => {
    setPage((prevPage) => prevPage + 1);
  };

  return (
    <>
      <ArticalListBanner />
      <section className="articals_wrapper py-3 margin_bottomfooter">
        <Container fluid>
          <Row className="mb-4 justify-content-center">
            <Col xl={12} lg={12}>
              {loading ? (
                <div className="text-center py-5">
                  <Spinner animation="border" style={{ color: "#09422d" }} />
                </div>
              ) : error ? (
                <Alert variant="danger" className="text-center">
                  {error}
                </Alert>
              ) : (
                <Row className="justify-content-center gx-xl-5">
                  <Col className="col-lg-8 col-xl-8 col-xxl-9 ps-xl-0">
                    <Row className="row-cols-1 row-cols-sm-2 row-cols-md-2 row-cols-lg-2 row-cols-xl-2 row-cols-xxl-3 gx-xxl-5 gx-lg-4">
                      {articles.map((article, index) => (
                        <Col
                          key={article.id || index}
                          xl={3}
                          lg={4}
                          md={6}
                          sm={6}
                          className="mb-5"
                        >
                          <ArticlesCard article={article} />
                        </Col>
                      ))}
                    </Row>

                    {/* Load More Button */}
                    {hasMore && (
                      <div className="text-center my-4">
                        <Button
                          onClick={handleLoadMore}
                          variant="success"
                          disabled={loadingMore}
                        >
                          {loadingMore ? "Loading..." : "Load More"}
                        </Button>
                      </div>
                    )}
                  </Col>
                  <Col lg={3} xl={3} xxl={2} className="pe-xl-0">
                    <CategorisRecentPost />
                  </Col>
                </Row>
              )}
            </Col>
          </Row>
        </Container>
      </section>
    </>
  );
}

export default ArticalList;
